export default __webpack_public_path__ + "media/examples/interactive-9ae45d4e.jpg";